import React from 'react';

export const isNumeric = (value) => {
  return typeof value === 'number' && !isNaN(value);
}

export const toThousands = (num) => {
  if (num === undefined) return 0;
  var str = num.toString();
  var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
  return str.replace(reg, "$1,");
}

export const toFixed2 = (n, s) => {
  return (parseInt(n * Math.pow(10, s) + 0.5) / Math.pow(10, s)).toFixed(s);
}

export const sum = (arr) => {
  var s = 0;
  for (var i = arr.length - 1; i >= 0; i--) {
    s += arr[i];
  }
  return s;
}

export const parsePrice = (money) => {
  if (money === undefined) return <span style={{ color: 'red' }}>无单价</span>;
  let temp = money.toString();
  temp = temp.replace(',', '');
  try {
    temp = Number(temp)
  } catch (ex) {
    return '*';
  }
  if (typeof temp === 'number' && !isNaN(temp)) {
    if (temp >= 0) {
      return money;
    }
  }
  return '*';
}

export const calcProfitRate = (price1, price2, rate) => {
  if (price1 && price2 && rate) {
    return ((price1 * rate - price2) * 100.0 / (price1 * rate)).toFixed(2);
  } else {
    return '-';
  }
}